module.exports = __webpack_public_path__ + "img/confetti.34a27c75.png";